import Vue from 'vue'

Vue.filter('money', (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value)
})

Vue.filter('formatDateHora', (value) => {
  if (!value) return ''

  const date = new Date(value)
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')

  const formattedDate = `${day}/${month}/${year}`
  const formattedTime = `${hours}:${minutes}`

  return `${formattedDate} ${formattedTime}`
})

export default ({ app }, inject) => {
  const isDev = [
    'localhost',
    'homologacao.senhadigitalplus.com.br',
    'leonardo.senhadigitalplus.com.br',
    'link.senhadigitalplus.com.br',
  ].includes(window.location.hostname)
  inject('isDev', isDev)
  inject('normalizeAndLowercaseString', (str) => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036F]/g, '')
      .toLowerCase()
  })
}
